module.exports = __webpack_public_path__ + "img/eye.22dc44da.svg";